import React, { Profiler, useEffect, useState } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Success from "./pages/Success";
import Login from "./pages/Login";
import { RequireAuth } from "react-auth-kit";
import Home from "./pages/Home";
import Accueil from "./pages/PageAccueil";
import Signup from "./pages/Signup";
import Espace_Admin from "./pages/Espace_Admin";
import Espace_Perso from "./pages/Espace_Perso";
import Infospratiques from "./pages/Infospratiques";
import Contact from "./pages/Contact";




function App() {
  return (
    <>
      <Routes>
        <Route path={"/"} element={<Accueil />} />
        <Route path={"/login"} element={<Login />} />

        <Route path={"/contact"} element={<Contact />} />

        <Route path={"/infospratiques"} element={<Infospratiques />} />

        <Route path={"/signup"} element={<Signup />} />
        <Route
          path={"/success"}
          element={
            <RequireAuth loginPath={"/login"}>
              <Success />
            </RequireAuth>
          }

        />

        <Route
          path={"/Espace_Admin"}
          element={
            <RequireAuth loginPath={"/login"}>
              <Espace_Admin />
            </RequireAuth>
          }

        />

        <Route
          path={"/Espace_Perso"}
          element={
            <RequireAuth loginPath={"/login"}>
              <Espace_Perso />
            </RequireAuth>
          }

        />

      </Routes>

    </>
  );
}

export default App;
